import React, { Component } from 'react';

// Ícone de ajuda reaproveitado por todos os cards/gráficos do Dashboard, explicando como cada
// métrica é calculada. Usa o atributo nativo `title` (sem `Tooltip` standalone do PrimeReact) —
// espelho de hay-hotspot/assets/reactweb/src/pages/Auth/Dashboard/DashboardAjuda.js.
class DashboardAjuda extends Component {
  render() {
    const { texto } = this.props;
    if (!texto) return null;
    return (
      <i
        className="pi pi-info-circle text-color-secondary ml-1"
        style={{ fontSize: '0.75rem', cursor: 'help' }}
        title={texto}
      />
    );
  }
}

export default DashboardAjuda;
